/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

exports.shouldUpdateScroll = args => {
  // TODO: Better implementation
  // console.log(args)
  return false
}



// WEBPACK FOOTER //
// ./gatsby-browser.js